var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PartnerHeader',{attrs:{"img_header":_vm.header_image,"header":"รายการจัดการ POS","link_back":"storeinformation"}}),_c('Store_invoice_information')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }